import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Icon from './Icon';
import utils from './utils';
import paramUtils from './paramUtils';
import { datepickerClass } from './styles';
import { getLocale } from '../locale';
import { isArray, isNumber } from '../utils/is';
var Quarters = ['Q1', 'Q2', 'Q3', 'Q4'];

var Quarter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Quarter, _PureComponent);

  var _super = _createSuper2(Quarter);

  function Quarter(props) {
    var _this;

    _classCallCheck(this, Quarter);

    _this = _super.call(this, props);
    _this.handleNextYear = void 0;
    _this.handlePrevYear = void 0;
    _this.handleNextYear = _this.handleYearChange.bind(_assertThisInitialized(_this), 1);
    _this.handlePrevYear = _this.handleYearChange.bind(_assertThisInitialized(_this), -1);
    _this.handleQuarterClick = _this.handleQuarterClick.bind(_assertThisInitialized(_this));
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    props.disabledRegister(_this.handleDisabled, 'quarter', props.index);
    return _this;
  }

  _createClass(Quarter, [{
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleYearChange",
    value: function handleYearChange(year) {
      var _this$props = this.props,
          current = _this$props.current,
          onChange = _this$props.onChange;
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(utils.addYears(current, year, this.getOptions()))));
    }
  }, {
    key: "handleYearClick",
    value: function handleYearClick() {
      this.props.onModeChange('year');
    }
  }, {
    key: "handleQuarterClick",
    value: function handleQuarterClick(date) {
      var onChange = this.props.onChange;
      onChange.apply(void 0, _toConsumableArray(paramUtils.quarterHandleChangeParams(date, true, true)));
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(date) {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          index = _this$props2.index,
          min = _this$props2.min,
          max = _this$props2.max,
          rangeDate = _this$props2.rangeDate,
          range = _this$props2.range,
          type = _this$props2.type;
      var isDisabled = min && utils.compareQuarter(min, date, 1, this.getOptions()) >= 0;

      if (!isDisabled) {
        isDisabled = max && utils.compareQuarter(date, max, 1, this.getOptions()) >= 0;
      }

      if (!isDisabled && type === 'quarter' && typeof disabled === 'function') {
        isDisabled = disabled(date);
      }

      if (!isDisabled && index === 1 && isArray(rangeDate)) {
        if (isNumber(range) && rangeDate[0] && utils.compareAsc(date, utils.addSeconds(rangeDate[0], range, this.getOptions())) > 0) {
          isDisabled = true;
        }
      }

      return isDisabled;
    }
  }, {
    key: "renderQuarter",
    value: function renderQuarter(q, i) {
      var _this$props3 = this.props,
          current = _this$props3.current,
          index = _this$props3.index,
          rangeDate = _this$props3.rangeDate,
          value = _this$props3.value;
      var year = utils.getDateInfo(current, 'year', this.getOptions());
      var date = utils.parse("".concat(year, " ").concat(i + 1), 'YYYY Q', this.getOptions());
      var isDisabled = this.handleDisabled(date); // let hoverClass

      var classList = [isDisabled && 'disabled'];

      if (rangeDate && index !== undefined) {
        if (utils.isSameQuarter(date, rangeDate[index], this.getOptions())) {
          classList.push('active');
        } // hoverClass = datepickerClass(
        //   rangeDate[0] &&
        //     utils.compareQuarter(rangeDate[0], date) <= 0 &&
        //     rangeDate[1] &&
        //     utils.compareQuarter(rangeDate[1], date) >= 0 &&
        //     'hover',
        //   // Datetime Picker range end datetime classname #330
        //   utils.isSameQuarter(rangeDate[index], date) && `hover-${index === 0 ? 'start' : 'end'} active`
        // )

      } else if (value) {
        if (utils.isSameQuarter(date, value, this.getOptions())) {
          classList.push('active');
        }
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: date.getTime() // className={hoverClass}
          ,
          onClick: isDisabled ? undefined : this.handleQuarterClick.bind(this, date, undefined)
        },
        /*#__PURE__*/
        React.createElement("span", {
          className: datepickerClass.apply(void 0, classList)
        }, q))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var current = this.props.current;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('quarter-picker')
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('header')
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleLeft",
          className: "left",
          onClick: this.handlePrevYear
        }),
        /*#__PURE__*/
        React.createElement("span", {
          onClick: this.handleYearClick.bind(this),
          className: datepickerClass('ym')
        }, utils.getDateInfo(current, 'year', this.getOptions())),
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleRight",
          className: "right",
          onClick: this.handleNextYear
        })),
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('list')
        }, Quarters.map(function (q, i) {
          return _this2.renderQuarter(q, i);
        })))
      );
    }
  }]);

  return Quarter;
}(PureComponent);

export default Quarter;